import constants from './constants';

const actions = {
  setQuery: function(query) {
    this.dispatch(constants.SET_QUERY, query);
  }
}

export default actions;
